import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {EffectsModule} from '@ngrx/effects';
import {AnalyticsEffects} from './analytics.effects';

@NgModule({
  declarations: [],
  imports: [CommonModule, EffectsModule.forFeature([AnalyticsEffects])],
  exports: [],
})
export class CoreModule {}
